/* istanbul ignore file */

export const FIELD_TYPE_EMPTY_VALUES_CONSTANTS = {
    TextAreaEmptyParagraphTag: '<p></p>'
};
